<template>
  <div class="item-container">
    <div class="text-muted cs-textstyle-paragraph-small-bold col-small">
      <div>{{ podcast.created_at | moment('dddd') }}</div>
      <div>{{ podcast.created_at | moment('DD MMM YYYY') }}</div>
      <div class="pt-3 d-flex flex-row">
        <a @click.stop="onOpenPodcast(podcast.enclosure_url)"
          ><div class="icon-circle text-white mr-2">
            <i class="cs-icons-play-filled"></i>
          </div>
        </a>
        <span class="cs-textstyle-paragraph-small">{{ time }}</span>
      </div>
    </div>
    <div class="col-large">
      <div class="cs-textstyle-item-heading">{{ podcast.title }}</div>
      <div class="cs-textstyle-paragraph">
        <app-expandable-text
          :content="podcast.description | text"
          placeholder="No description"
        />
      </div>
    </div>
  </div>
</template>

<script>
import AppExpandableText from '@/components/global/ExpandableText.vue';
export default {
  components: {
    AppExpandableText
  },
  props: {
    podcast: {
      type: Object,
      required: true
    }
  },
  computed: {
    time() {
      let sec = this.podcast.duration;
      let hours = Math.floor(sec / 3600);
      hours >= 1 ? (sec = sec - hours * 3600) : (hours = '00');
      let min = Math.floor(sec / 60);
      min >= 1 ? (sec = sec - min * 60) : (min = '');
      min.toString().length == 1 ? (min = '0' + min) : min;
      if (hours > 0) {
        return hours + ' hr ' + min + `${min > 0 ? 'mins' : ''}`;
      } else return min + ' mins ';
    }
  },
  methods: {
    onOpenPodcast(url) {
      window.open(url, '_blank');
    }
  }
};
</script>

<style scoped lang="scss">
.col-small {
  width: 25%;
  padding-left: 0px;
  @include media-breakpoint-up(md) {
    width: 15%;
    padding-left: 5px;
    padding-top: 2px;
  }
  @include media-breakpoint-up(lg) {
    padding-left: 20px;
    padding-top: 2px;
  }
}
.col-large {
  width: 75%;
  @include media-breakpoint-up(lg) {
    width: 85%;
  }
}
.item-container {
  display: flex;
  flex-direction: row;
  padding: 20px;
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.03);
  border-radius: 5px;
  background: var(--cs-gray-00);
  cursor: pointer;
}
.icon-circle {
  height: 24px;
  width: 24px;
  border-radius: 50%;
  background: $primary;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 15px;
  padding: 2px 0px 0px 1px;
}
.description {
  word-break: break-word;
}
</style>
